import { isStanbridgeClient } from '@/composables/useEdverumClient.js';
import UserGroup from '@/models/UserGroup.js';

export function isStudentSmsEnabled() {
    return window.__INITIAL_STATE__?.EnvironmentSettings?.student_sms_enabled === true;
}

export function canViewStudentSupportDashboard(user) {
    if (!isStanbridgeClient() || !user) return false;

    const permission = 'view student support dashboard';
    return (
        user.hasPermissionTo(permission) ||
        UserGroup.query()
            .where('user_id', user.id)
            .whereHas('role', query =>
                query.whereHas('permissions', permissions => permissions.where('name', permission))
            )
            .exists()
    );
}
